import { render, staticRenderFns } from "./NewBookinfModal.vue?vue&type=template&id=005c3d4a&scoped=true"
import script from "./NewBookinfModal.vue?vue&type=script&lang=js"
export * from "./NewBookinfModal.vue?vue&type=script&lang=js"
import style0 from "./NewBookinfModal.vue?vue&type=style&index=0&id=005c3d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c3d4a",
  null
  
)

export default component.exports